import {
  App,
  Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Flex,
  Form,
  Input,
  Row,
  Select,
  Spin,
} from 'antd';
import React, { useEffect, useState } from 'react';
import Heading from '../../common/Heading/Heading';
import { useNavigate, useParams } from 'react-router-dom';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '../../../services/react-query/queryKeys';
import {
  addAccountingPeriod,
  getAccountingPeriodById,
  updateAccountingPeriod,
} from '../../../network/accountPeriod';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import HeadingApp from '../../../hooks/HeadingApp';
import { MdAccountBalanceWallet } from 'react-icons/md';
const closedDocuments = [
  {
    document_type: 'Sales Invoice',
    closed: 0,
  },
  {
    document_type: 'Purchase Invoice',
    closed: 0,
  },
  {
    document_type: 'Journal Entry',
    closed: 0,
  },
  {
    document_type: 'Bank Clearance',
    closed: 0,
  },
  {
    document_type: 'Stock Entry',
    closed: 0,
  },
  {
    document_type: 'Payment Entry',
    closed: 0,
  },
  {
    document_type: 'Period Closing Voucher',
    closed: 0,
  },
  {
    document_type: 'Process Deferred Accounting',
    closed: 0,
  },
  {
    document_type: 'Asset',
    closed: 0,
  },
  {
    document_type: 'Landed Cost Voucher',
    closed: 0,
  },
  {
    document_type: 'Purchase Receipt',
    closed: 0,
  },
  {
    document_type: 'Stock Reconciliation',
    closed: 0,
  },
  {
    document_type: 'Payroll Entry',
    closed: 0,
  },
];
const AddAccountPeriod = ({ t, edit }) => {
  const client = useQueryClient();
  const { companyName } = useSelector((state) => state.user);
  const { id } = useParams();
  const [loadingAdd, setLoadingAdd] = useState(false);
  const [searchTxt, setSearchTxt] = useState('');
  const { message } = App.useApp();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { mutate: onAddModeOfPayment } = useMutation({
    mutationKey: ['addModeOfPayment'],
    mutationFn: (body) =>
      edit ? updateAccountingPeriod(body, id) : addAccountingPeriod(body),
    onSuccess: (data) => {
      setLoadingAdd(false);
      console.log(data?.message, 'datawwww');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message?.message);
      client.invalidateQueries({ queryKey: [queryKeys.getAccountingPeriod] });

      form.resetFields();
      navigate('/account-period');
    },
    onError: (error) => {
      setLoadingAdd(false);
      console.log('error:', error);
      // message.error(error);
    },
  });
  const { data: modeOfPayment, isLoading } = useQuery({
    queryKey: [queryKeys.getAccountingPeriodById, id],
    queryFn: () => getAccountingPeriodById(id),
    enabled: !!id,
  });

  const onFinish = (values) => {
    setLoadingAdd(true);
    console.log(values, 'values');
    // console.log(
    //   {
    //     ...values,
    //     company: companyName,
    //     start_date: dayjs(values?.start_date).format('YYYY-MM-DD'),
    //     end_date: dayjs(values?.end_date).format('YYYY-MM-DD'),
    //     closed_documents: values?.closed_documents?.map((item) => ({
    //       document_type: item,
    //       closed: 1,
    //     })),
    //   },
    //   'data et'
    // );

    onAddModeOfPayment({
      ...values,
      company: companyName,
      start_date: dayjs(values?.start_date).format('YYYY-MM-DD'),
      end_date: dayjs(values?.end_date).format('YYYY-MM-DD'),
      closed_documents: values?.closed_documents?.map((item) => ({
        document_type: item,
        closed: 1,
      })),
    });
  };
  useEffect(() => {
    if (modeOfPayment?.data) {
      form.setFieldsValue({
        ...modeOfPayment?.data,
        closed_documents: modeOfPayment?.data?.closed_documents?.map(
          (item) => item?.document_type
        ),
        start_date: dayjs(modeOfPayment?.data?.start_date),
        end_date: dayjs(modeOfPayment?.data?.end_date),
      });
    }
  }, [modeOfPayment, form]);
  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div className="mode-of-payment-add">
      {/* <Heading
        title={t.AccountPeriod}
        subTitle={t.AddAccountPeriod}
        path="/account-period"
      /> */}
      <HeadingApp
        nameTab={t.SalesFinance}
        title={t.AccountPeriod}
        subTitle={edit ? t.editAccountPeriod : t.AddAccountPeriod}
        icon={<MdAccountBalanceWallet />}
      />
      <Card style={{ borderRadius: '0px' }}>
        {/* <h4 className="title-card">{t.AccountPeriodInformation}</h4> */}
        <Form
          layout="vertical"
          name="mode-of-payment-form"
          onFinish={onFinish}
          form={form}
        >
          <Row gutter={[16, 0]}>
            <Col xs={24} md={24} lg={18}>
              <Row gutter={[16, 0]}>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="period_name"
                    label={t.periodName}
                    // label={t.name}
                    rules={[{ required: true }]}
                  >
                    <Input placeholder={t.periodName} />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="start_date"
                    label={t.startDate}
                    // label={t.name}
                    rules={[{ required: true }]}
                  >
                    <DatePicker
                      placeholder={t.startDate}
                      style={{ width: '100%' }}
                      format="YYYY-MM-DD"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="end_date"
                    label={t.EndDate}
                    // label={t.name}
                    rules={[{ required: true }]}
                  >
                    <DatePicker
                      placeholder={t.EndDate}
                      style={{ width: '100%' }}
                      format="YYYY-MM-DD"
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    name="closed_documents"
                    label={t.closedDocuments}
                    rules={[{ required: true }]}
                    // initialValue={closedDocuments?.map((item) => item?.document_type)}
                    valuePropName="checked"
                  >
                    <Checkbox.Group
                      // options={closedDocuments?.map((item) => item?.document_type)}
                      style={{ width: '100%' }}
                      defaultValue={
                        modeOfPayment?.data?.closed_documents?.map(
                          (item) => item?.document_type
                        ) || []
                      }
                    >
                      <Row gutter={[16, 16]}>
                        {closedDocuments?.map((item) => (
                          <Col
                            xs={24}
                            sm={12}
                            md={12}
                            lg={8}
                            xl={6}
                            key={item?.document_type}
                          >
                            <Checkbox value={item?.document_type}>
                              {item?.document_type}
                            </Checkbox>
                          </Col>
                        ))}
                      </Row>
                    </Checkbox.Group>
                  </Form.Item>
                </Col>
              </Row>
              <div className="form-btns">
                <Button
                  type="primary"
                  ghost
                  onClick={() => navigate('/modeofpayments')}
                >
                  {t.Cancel}
                </Button>
                <Button type="primary" htmlType="submit" loading={loadingAdd}>
                  {edit ? t.edit : t.submit}
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </Card>
    </div>
  );
};

export default AddAccountPeriod;
